









































































































































import { Vue, servicesURL } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import EventBus from '../../eventBus';

export default Vue.component("top-up", {
  props: {
    remainingamount: "",
  },
  data() {
    return {
      servicesURL,
      staticContent,
      showAdd: false,
      modalId: "topup-modal",
      creditAmount: "",
    };
  },
  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    creditCards() {
      return this.$store.state.creditCards;
    },
    profile() {
      return this.$store.state.profile;
    },
    loading() {
      return this.$store.state.cardsLoading;
    },
    group() {
      return this.$store.state.groupBasket;
    },
    basket() {
      return this.$store.state.basket;
    },
    topup() {
      return this.$store.state.topup;
    },
    basketCompact() {
      return this.$store.state.basketCompact;
    },
  },
  mounted() {
    this.creditAmount =
      this.remainingamount > 0 ? Math.floor(this.remainingamount) : "";
  },
  methods: {
    getTitle(key) {
      return this.$root.getTextFromRemoteConfig(key);
    },
    openConfirmationModal() {
      const $body = document.getElementById('checkout-modal');
      $body.classList.add("no-scroll");
      this.modalToggler("confirmation-modal", "show");
    },
    handleTopup() {
      this.closeConfirmModal()
      let data = {
        cardUUID: this.topup.payment.cardUUID,
        amount: this.creditAmount,
        basketUUID: this.basket.uuid,
      };
      this.$store
        .dispatch("APPLY_TOP_UP", data)
        .then((res) => {
          this.resetTopup()
          this.modalToggler("topup-modal", "hide");
          EventBus.$emit('openNotyf', ['success', staticContent.topup.success])

          this.$store.dispatch("getUserProfileData", false);

          // callinf details and summary after top up when the remaining amount greater that 1
          if(this.remainingamount > 1) {
            this.$store.dispatch("GET_USER_BASKET");
            // delay calling summary to be updated after top up
            setTimeout(() => {
              this.$store
              .dispatch("GET_GROUP_BASKET_SUMMARY", this.basketCompact.uuid);
            }, 100)
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    closeConfirmModal() {
      const $body = document.getElementById('checkout-modal');
      $body.classList.remove("no-scroll");
      this.modalToggler("confirmation-modal", "hide");
    },
    modalToggler(modalId, type) {
      this.$root.modalToggler(modalId, type);
    },
    showAddCard() {
      this.showAdd = true;
    },
    closeModal() {      
      this.resetTopup();
      this.modalToggler("topup-modal", "hide");
    },
    resetTopup() {
      this.showAdd = false;
      this.creditAmount =
        this.remainingamount > 0 ? Math.floor(this.remainingamount) : "";
      this.creditCards.length && this.$store.commit("updateTopupPaymentCard", this.creditCards[0].uuid);
    },
    handleCloseAdd() {
      this.showAdd = false;
    },
    handleChangeValue(e, v) {
      this.creditAmount = e.target.value;
    },
  },
  watch: {
    // whenever question changes, this function will run
    remainingamount: function (newVal, oldVal) {
      this.creditAmount = newVal > 0 ? Math.floor(newVal) : "";
    },
  },
});
